module.exports = __webpack_public_path__ + "img/thumb_25.8fcd2c0e.jpg";